import React, { useEffect, useState } from 'react'
import LeadSourceForm from '../../components/Forms/LeadSource/LeadSourceForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { useLeadSource } from '../../hooks/CompanyConfiguration/useLeadSource'
import { ROUTES } from '../../shared/constants'

export default function AddLeadSource({ leadSource }) {
  const { addLeadSource, updateLeadSource, loading } = useLeadSource()
  const [leadSourceForm, setLeadSourceForm] = useState({
    name: '',
  })
  //console.log('TAX : ', leadSourceForm)
  const handleAddLeadSource = () => {
    if (leadSource) {
      updateLeadSource({
        leadSourceId: leadSource._id,
        name: leadSourceForm.name,
      })
    } else {
      addLeadSource({
        name: leadSourceForm.name,
      })
    }
  }

  useEffect(() => {
    if (leadSource) {
      setLeadSourceForm({
        ...leadSourceForm,
        name: leadSource.name,
      })
    }
  }, [leadSource])

  return (
    <Layout heading="Lead Source" heading2={leadSource ? 'Edit' : 'Add'} url1={ROUTES.LEADSOURCE} none>
      <HeaderTabLayout
        heading={`${leadSource ? 'Edit' : 'Add'} Lead Source`}
        content={<CustomAddForm state={leadSourceForm} setState={setLeadSourceForm} data={[{ label: 'Name', value: leadSourceForm.name, name: 'name' }]} />}
        addContent={handleAddLeadSource}
        redirect={ROUTES.LEADSOURCE}
        loading={loading}
        state={leadSourceForm} setState={setLeadSourceForm}
      />
    </Layout>
  )
}
